import Chart from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

export const ReviewCategoriesChartConfigMixin = {
  props: {
    labels: {
      type: Array,
      default: () => []
    },
    data: {
      type: Object,
      default: () => {}
    },
    selectedCategory: {
      type: Object
    }
  },
  beforeCreate() {
    Chart.plugins.unregister(ChartDataLabels);
  },
  mounted() {
    this.render();
  },
  updated() {
    this.render();
  },

  watch: {
    labels() {
      this.render();
    },
    data() {
      this.render();
    }
  }
};
